import { render, staticRenderFns } from "./CalcFormula.vue?vue&type=template&id=80e45cb4&scoped=true"
import script from "./CalcFormula.vue?vue&type=script&lang=js"
export * from "./CalcFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e45cb4",
  null
  
)

export default component.exports